import React, { SFC } from 'react';
import Ink from '../Ink';
import ToolbarItem, { ToolbarItemProps } from '../ToolbarItem';
import { WithStyles, createStyles, withStyles } from '../styles';
import { cx } from '../utils';

const styles = createStyles<'root' | 'active'>(theme => ({
  root: {
    cursor: 'pointer',
    outline: 0,
    transition: 'background-color 140ms',
    borderRadius: 3,
    '&:hover': {
      backgroundColor: theme.color('grey', '50'),
    },
    '&:active': {
      compose: '$active',
    } as any,
  },
  active: {
    backgroundColor: theme.color('grey', '50'),
  },
  // TODO: disabled
}));

export interface ToolbarButtonProps extends ToolbarItemProps {
  active?: boolean;
  disabled?: boolean;
}

type Props = WithStyles<ToolbarButtonProps, typeof styles>;

const ToolbarButton: SFC<Props> = ({
  active,
  children,
  className,
  classes,
  disabled,
  theme,
  ...rest
}) => (
  <ToolbarItem
    className={cx(classes.root, active && classes.active, className)}
    tabIndex={disabled ? -1 : 0}
    {...rest}
  >
    {children}
    <Ink disabled={disabled} />
  </ToolbarItem>
);

export default withStyles(styles)(ToolbarButton);
